import * as React from 'react';
import { Field, useField, FormikHandlers, FieldValidator } from 'formik';

interface Select {
  label: string;
  name: string;
  id?: string;
  className?: string;
  autoComplete?: string;
  onFocus?: React.FocusEventHandler;
  onBlur?: FormikHandlers['handleBlur'];
  onChange?: FormikHandlers['handleChange'];
  validate?: FieldValidator;
  children: React.ReactElement | (React.ReactElement | null)[];
}

function Select({
  id,
  label,
  name,
  className = '',
  autoComplete = '',
  onBlur,
  onChange,
  onFocus,
  validate,
  children
}: Select): React.ReactElement {
  const [field, meta] = useField(name);

  return (
    <>
      <div className={`select ${meta.touched && meta.error ? 'select--has-error' : ''}`}>
        <Field
          as="select"
          id={id || field.name}
          name={field.name}
          value={field.value}
          onBlur={onBlur || field.onBlur}
          onChange={onChange || field.onChange}
          onFocus={onFocus}
          autoComplete={autoComplete}
          validate={validate}
          className={`select__field ${className} ${field.value ? 'select__field--has-value' : ''}`}
        >
          {children}
        </Field>
        <label className="select__label" htmlFor={id || field.name}>
          {label}
        </label>
        <span className="select__decoration" />
      </div>
      {meta.touched && meta.error ? (
        <p className="select__error" role="alert">
          {meta.error}
        </p>
      ) : null}
    </>
  );
}

export default Select;
